import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { Provider } from '@angular/core';
import { recaptchaTokenInterceptor } from '../interceptors/recaptcha-token/recaptcha-token.interceptor';

export function provideRecaptchaTokenInterceptor(): Provider {
  return [provideHttpClient(withInterceptors([recaptchaTokenInterceptor]))];
}
